import useLabels from '~hooks/useLabels';
import { Customize } from '~modules/newsfeed/Customize';

export function Header({ title }: { title?: string }) {
  const { hlNewsfeedFeed } = useLabels(['hlNewsfeedFeed']);
  return (
    <div className="feed--header flex justify-between items-center mb-4">
      <div className="text-xl">{title || hlNewsfeedFeed}</div>
      <div>
        <Customize />
      </div>
    </div>
  );
}
